import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import MarketingLayout from "@/components/MarketingLayout";
import ProtectedRoute from "@/components/ProtectedRoute";

import HomePage from "@/pages/HomePage";
import ServicesPage from "@/pages/ServicesPage";
import TeamPage from "@/pages/TeamPage";
import InsightsPage from "@/pages/InsightsPage";
import ContactPage from "@/pages/ContactPage";
import BookingPage from "@/pages/BookingPage";
import GovernmentPage from "@/pages/GovernmentPage";
import FederalEmployeesPage from "@/pages/FederalEmployeesPage";
import ClientsPage from "@/pages/ClientsPage";
import DisclosuresPage from "@/pages/DisclosuresPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";

import PortalLoginPage from "@/pages/portal/PortalLoginPage";
import PortalShell from "@/pages/portal/PortalShell";
import DashboardPage from "@/pages/portal/DashboardPage";
import DocumentsPage from "@/pages/portal/DocumentsPage";
import MessagesPage from "@/pages/portal/MessagesPage";
import AppointmentsPage from "@/pages/portal/AppointmentsPage";
import AdminPage from "@/pages/portal/AdminPage";

const wrap = (Page) => (
  <MarketingLayout><Page /></MarketingLayout>
);

const portalWrap = (Page) => (
  <ProtectedRoute><PortalShell><Page /></PortalShell></ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={wrap(HomePage)} />
            <Route path="/services" element={wrap(ServicesPage)} />
            <Route path="/our-clients" element={wrap(ClientsPage)} />
            <Route path="/federal-employees" element={wrap(FederalEmployeesPage)} />
            <Route path="/government" element={wrap(GovernmentPage)} />
            <Route path="/team" element={wrap(TeamPage)} />
            <Route path="/insights" element={wrap(InsightsPage)} />
            <Route path="/contact" element={wrap(ContactPage)} />
            <Route path="/book" element={wrap(BookingPage)} />
            <Route path="/disclosures" element={wrap(DisclosuresPage)} />
            <Route path="/privacy" element={wrap(PrivacyPage)} />
            <Route path="/terms" element={wrap(TermsPage)} />
            <Route path="/refunds" element={wrap(RefundPolicyPage)} />

            <Route path="/portal/login" element={<PortalLoginPage />} />
            <Route path="/portal/dashboard" element={portalWrap(DashboardPage)} />
            <Route path="/portal/documents" element={portalWrap(DocumentsPage)} />
            <Route path="/portal/messages" element={portalWrap(MessagesPage)} />
            <Route path="/portal/appointments" element={portalWrap(AppointmentsPage)} />
            <Route path="/portal/admin" element={portalWrap(AdminPage)} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
